<div class="cbm-item"
  [ngClass]=" {'cbm-item-selected' : selected }"
  (click)="clicked()">

  <div class="d-flex flex-row align-items-center" style="flex: 3">
    <div class="d-flex flex-column align-items-center">
      <div class="cmb-circle"
        [ngClass]=" {'cmb-circle-selected' : selected }">
        @if (selected) {
          <div>{{ selectionOrder == 0 ? '1st':'2nd' }}</div>
        }
      </div>
      @if (selected) {
        <div class="cbm-choice">Choice</div>
      }
      @if (!selected) {
        <div class="cbm-choice" style="color: transparent;">Choice</div>
      }
    </div>
    <div class="cbm-detail">
      @if (recommended) {
        <div class="detail-recommend">Top Recommended</div>
      }
      <div class="detail-name" (click)="viewDetail($event)">{{ name }}</div>
      <div class="detail-tags">
        @for (item of tags; track item; let index = $index) {
          <div>{{ item }} </div>
        }
      </div>
      <div class="detail-view" (click)="viewDetail($event)">
        View Details & Reviews
      </div>
    </div>
  </div>
  <div style="flex:1;" class="pcab">
    {{ pcab }}
  </div>
  <div style="flex:1;" class="pcab">
    <!-- <img    class="star"
    alt="star-icon"
    *ngFor=" let x of [].constructor(rating)"
    src="assets/img/icons/cb_star_active.svg">
    <img    class="star"
      alt="star-icon"
      *ngFor=" let x of [].constructor(5-rating)"
      src="assets/img/icons/cb_star_inactive.svg"> -->
      <app-starshading  [rating]="getRatingValue(ratingValueFin)" [reviews]="feedbacks.length"></app-starshading>

    </div>
    <div class="detail-tags-mobile">
      @for (item of tags; track item; let index = $index) {
        <div>{{ item }}</div>
      }
    </div>
  </div>
